import { formatPhoneDisplay } from '@cowbell/broker/phone';

/** A phone number with its country code and the number as that country writes it: +1 (316) 258-4026. */
export const formatAsPhone = (string = '') => {
  if (typeof string !== 'string') {
    return string;
  }
  return formatPhoneDisplay(string);
};

export const truncateString = (str = '', n: any) => {
  return str.length > n ? `${str.substr(0, n - 1)}...` : str;
};

export const titleCase = (string: any) => {
  return string[0].toUpperCase() + string.slice(1).toLowerCase();
};

export function getFileName(string: any) {
  const parts = string.split('.');
  parts.pop();
  return parts.join('.');
}

export function getFileExtension(string: any) {
  const parts = string.split('.');
  return parts.pop();
}
